// extracted by mini-css-extract-plugin
module.exports = {"buttonSuccess":"Style_buttonSuccess__2A-k_","buttonEdit":"Style_buttonEdit__2L1mV","buttonError":"Style_buttonError__3BXmv","buttonLogin":"Style_buttonLogin__12X7v"};